import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-account-deleted',
  templateUrl: './account-deleted.component.html',
  styleUrls: ['./account-deleted.component.scss'],
})

/**
 * Account deleted component!
 */
export class AccountDeletedComponent implements OnInit {
  labels = {
    pageTitle: 'delete-account',
    infos: 'delete-account-successful-informative-text',
  };
  timeOut = 7000;

  /**
   * @constructor
   */
  constructor(
    private translationService: TranslationService,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);

    this.authenticationService.logout();

    setTimeout(() => {
      this.router.navigate([RoutesKeys.HOME]);
    }, this.timeOut);
  }
}
